<script setup lang="ts">
/**
 * v-model text/number input carrying the canonical builder input classes.
 * `size="sm"` → h-9 text-sm; `size="xs"` → h-8 text-xs (advanced fields).
 */
const props = withDefaults(defineProps<{
  modelValue?: string | number | null
  type?: string
  placeholder?: string
  size?: 'sm' | 'xs'
  min?: string | number
  max?: string | number
  number?: boolean
}>(), {
  type: 'text',
  size: 'sm',
})

const emit = defineEmits<{ 'update:modelValue': [value: string | number] }>()

const sizeClass = computed(() =>
  props.size === 'xs' ? 'h-8 px-2.5 text-xs' : 'h-9 px-3 text-sm',
)

function onInput(e: Event) {
  const raw = (e.target as HTMLInputElement).value
  emit('update:modelValue', props.number ? Number(raw) : raw)
}
</script>

<template>
  <input
    :value="modelValue ?? ''"
    :type="type"
    :placeholder="placeholder"
    :min="min"
    :max="max"
    :class="sizeClass"
    class="w-full rounded-md border border-input bg-transparent placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    @input="onInput"
  />
</template>
